module.exports = __webpack_public_path__ + "static/media/linkExternal.6aeb2455.svg";